<!--  это полноценный вариант бронирования -->

<template>
    <div v-if="showModal">
        <b-modal
            v-model="showModalLocal"
            :title="'Добавление брони'"
            class="modal-primary"
            size="xl"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <b-tabs v-model="booking_type">
                <b-tab title="ПК - загрузить" :disabled="!enableProfkurort">
                    <template v-if="booking_type===0">
                        <b-form-group
                            label="Идентификатор брони профкурорта"
                            description="Идентификатор существующей брони профкурорта в виде 61577/09-2019"
                            :state="validateState('external_id')"
                            :invalid-feedback="veeErrors.first('external_id')"
                        >
                            <b-form-input type="text"
                                          v-model="external_id"
                                          v-validate="{max:32,required:true, regex:/^\d{1,6}\/\d{2}-\d{4}(?:\/\d+)?$/}"
                                          id="external_id"
                                          name="external_id"
                                          data-vv-as="'Идентификатор брони'"
                                          :state="validateState('external_id')"
                            ></b-form-input>
                        </b-form-group>


                    </template>
                </b-tab>

                <b-tab title="Счет от объекта" :disabled="!enableInvoice">
                    <template v-if="booking_type===1">

                        <div class="row">
                            <div class="col">
                                <b-form-group>
                                    <b-form-group label="Поставщик: " label-for="basicSelect" :label-cols="3"
                                                  :horizontal="false   ">
                                        <v-select
                                            v-model="supplier_id"
                                            :options="companies"
                                            placeholder="Компания поставщик"
                                            label="title"
                                            :reduce="x=>x.id"
                                        ></v-select>
                                    </b-form-group>
                                </b-form-group>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col col-lg-6">
                                <b-form-group label="Номер счета от объекта"
                                              :state="validateState('invoice_number')"
                                              :invalid-feedback="veeErrors.first('invoice_number')"
                                              required
                                >
                                    <b-form-input type="text"
                                                  v-model="invoice_number"
                                                  v-validate="{max:20,required:true}"
                                                  id="invoice_number"
                                                  name="invoice_number"
                                                  data-vv-as="'Номер счета'"
                                                  :state="validateState('invoice_number')"
                                    ></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col col-lg-6">
                                <b-form-group label="Дата счета"
                                              label-for="invoice_date"

                                              :invalid-feedback="veeErrors.first('invoice_date')"
                                              required
                                >
                                    <b-input-group style="witdh:100%">
                                        <v-date-picker
                                            v-model='invoice_date'
                                            id="invoice_date"
                                            name="invoice_date"
                                            data-vv-as="'Дата счета'"
                                            :state="validateState('invoice_date')"
                                            v-validate="{required:true}"
                                            :attributes="datepicker_attributes"
                                            @change="onChangeInvoiceDate"
                                            @input="onChangeInvoiceDate"
                                        >
                                            <b-form-input
                                                type="text"
                                                id="invoice_date_input"
                                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                                class="form-control form-date-picker"
                                                readonly
                                                :state="validateState('invoice_date')"
                                                v-bind="inputProps"
                                                v-on="inputEvents"/>
                                        </v-date-picker>
                                        <button type="button" class="btn btn-secondary"
                                                @click.prevent="invoice_date=null"><i class="fa fa-times"></i></button>
                                    </b-input-group>
                                </b-form-group>
                            </div>

                            <div class="col col-lg-6">
                                <b-form-group label="Дата заезда">
                                    <input class="form-control" :value='printDate(voucherx.date_begin_iso)' readonly/>
                                </b-form-group>
                            </div>

                            <div class="col col-lg-6">
                                <b-form-group
                                    label="Крайняя дата оплаты счета"
                                    label-for="redemption_date"
                                    description="Дата до которой должен быть оплачен счет, иначе он будет аннулирован"
                                    :state="validateState('redemption_date')"
                                    :invalid-feedback="veeErrors.first('redemption_date')"
                                >
                                    <b-input-group style="witdh:100%">
                                        <v-date-picker
                                            v-model='redemption_date'
                                            id="redemption_date"
                                            name="redemption_date"
                                            data-vv-as="'Крайняя дата оплаты счета'"
                                            :state="validateState('redemption_date')"
                                            :attributes="datepicker_attributes"
                                            :min-date='new Date()'
                                        >
                                            <input
                                                id="redemption_date_input"
                                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                                class="form-control form-date-picker"
                                                readonly
                                                v-bind="inputProps"
                                                v-on="inputEvents"

                                            />

                                        </v-date-picker>
                                        <button type="button" class="btn btn-secondary"
                                                @click.prevent="redemption_date=null"><i class="fa fa-times"></i>
                                        </button>
                                    </b-input-group>
                                </b-form-group>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col col-lg-6">
                                <b-form-group>
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="fee_included" value="1"
                                               v-model="fee_included" @change="onChangeFeeIncluded">
                                        <label class="custom-control-label" for="fee_included">Сумма счета включает
                                            агентское вознаграждение</label>
                                    </div>
                                </b-form-group>
                            </div>
                            <div class="col col-lg-6">
                                <b-form-group v-if="fee_included">
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="fee_to_be_payed"
                                               value="1" v-model="not_fee_to_be_payed" @change="onChangeFeeToBePayed">
                                        <label class="custom-control-label" for="fee_to_be_payed">Оплата за вычетом
                                            агентского</label>
                                    </div>
                                </b-form-group>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-lg-6">
                                <b-form-group
                                    label="Полная стоимость путевки"
                                    :invalid-feedback="veeErrors.first('price')"
                                >
                                    <b-form-input :value="_summa_full" readonly></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col col-lg-6">
                                <b-form-group
                                    label="Сумма счета"
                                    :state="validateState('invoice_value')"
                                    :invalid-feedback="veeErrors.first('invoice_value')"
                                    :description="invoice_value_not_changed?'расчитываеся автоматически как [сумма_путевки] - [вознаграждение]':''"
                                >
                                    <b-form-input type="text"
                                                  v-model.number="_invoice_value"
                                                  v-validate="{decimal:2,min_value:1,max_value:33000000,required:true}"
                                                  id="invoice_value"
                                                  name="invoice_value"
                                                  data-vv-as="'Сумма счета'"
                                                  :state="validateState('invoice_value')"
                                                  :class="invoiceValueClass"
                                                  @input="onChangeInvoiceValue"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>


                        <div class="row">

                            <div class="col col-12" v-if="minRewardPercent">
                                <b class="text-danger">
                                    минимальный % вознаграждения по программам в путевке {{ this.minRewardPercent }}%
                                </b>
                            </div>


                            <div class="col col-xs-6 col-lg-3">

                                <b-form-group
                                    label="Вознаграждение объекта"
                                    :state="validateState('fee_value')"
                                    :invalid-feedback="veeErrors.first('fee_value')"
                                    :description="'базовое вознаграждение объекта ' + formatPriceKop(_base_fee)"
                                >
                                    <b-form-input type="text"
                                                  v-model.number="_fee_value"
                                                  v-validate="{decimal:2,min_value:0,max_value:33000000,required:true}"
                                                  id="fee_value"
                                                  name="fee_value"
                                                  data-vv-as="'Вознаграждение объекта'"
                                                  :state="validateState('fee_value')"
                                                  @input="onChangeFee"
                                                  :class="feeValueClass"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col col-xs-6 col-lg-3">

                                <b-form-group
                                    label="% Вознаграждения"
                                    :state="validateState('fee_value')"
                                    :invalid-feedback="veeErrors.first('fee_value')"
                                    :description="'базовый % вознаграждения ' + hotel.procent_ref_obj + '%' + minRewardPercentText"
                                >
                                    <b-form-input type="text"
                                                  v-model.number="_fee_percent"
                                                  v-validate="{decimal:2,min_value:0,max_value:100,required:true}"
                                                  id="fee_percent"
                                                  name="fee_percent"
                                                  data-vv-as="'Вознаграждение объекта'"
                                                  :state="validateState('fee_percent')"
                                                  @input="onChangeFeePercent"
                                                  :class="feePercentClass"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col col-lg-6">
                                <b-form-group
                                    label="Сумма к оплате"
                                    :state="validateState('to_pay_value')"
                                    :invalid-feedback="veeErrors.first('to_pay_value')"
                                >
                                    <b-form-input type="text"
                                                  v-model.number="_to_pay_value"
                                                  v-validate="{decimal:2,min_value:1,max_value:33000000,required:true}"
                                                  id="to_pay_value"
                                                  name="to_pay_value"
                                                  data-vv-as="'Сумма к оплате'"
                                                  :state="validateState('to_pay_value')"
                                                  readonly
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-lg-12">
                                <b-form-group
                                    label='Загрузка документа'
                                    description='Подготовьте и загрузите документ'
                                    :state="validateState('text_admin_hidden')"
                                    :invalid-feedback="veeErrors.first('text_admin_hidden')"
                                >
                                    <b-form-file id="file-default" v-model='document_file'
                                                 placeholder="Выберите файл..."
                                                 drop-placeholder="Кидать файло сюды..."
                                    ></b-form-file>
                                </b-form-group>
                            </div>
                        </div>

                    </template>
                </b-tab>

                <b-tab title="Счет ожидается" :disabled="!enableInvoiceWait">
                    <template v-if="booking_type===2">

                        <div class="row">
                            <div class="col">
                                <b-form-group>
                                    <b-form-group label="Поставщик: " label-for="basicSelect" :label-cols="3"
                                                  :horizontal="false   ">
                                        <v-select
                                            v-model="supplier_id"
                                            :options="companies"
                                            placeholder="Компания поставщик"
                                            label="title"
                                            :reduce="x=>x.id"
                                        ></v-select>
                                    </b-form-group>
                                </b-form-group>
                            </div>
                        </div>

                        <div class="row">

                            <div class="col col-lg-6">
                                <b-form-group label="Дата заезда">
                                    <input class="form-control" :value='printDate(voucherx.date_begin_iso)' readonly/>
                                </b-form-group>
                            </div>

                            <div class="col col-lg-6">
                                <b-form-group
                                    label="Крайняя дата получения счета"
                                    label-for="wait_invoice_date"
                                    description="Дата до которой счет должен быть получен и введен в систему"
                                    :state="validateState('wait_invoice_date')"
                                    :invalid-feedback="veeErrors.first('wait_invoice_date')"
                                >
                                    <b-input-group style="witdh:100%">
                                        <v-date-picker
                                            v-model='wait_invoice_date'
                                            id="wait_invoice_date"
                                            name="wait_invoice_date"
                                            data-vv-as="'Крайняя дата получения счета'"
                                            :state="validateState('wait_invoice_date')"
                                            :attributes="datepicker_attributes"
                                            :min-date='new Date()'
                                            :max-date='(new Date()).addDays(3).correctWeekendForward()'

                                        >
                                            <input
                                                id="wait_invoice_date_input"
                                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                                class="form-control form-date-picker"
                                                readonly
                                                v-bind="inputProps"
                                                v-on="inputEvents"
                                            />

                                        </v-date-picker>
                                        <button type="button" class="btn btn-secondary"
                                                @click.prevent="wait_invoice_date=null"><i class="fa fa-times"></i>
                                        </button>
                                    </b-input-group>
                                </b-form-group>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col col-lg-6">
                                <b-form-group label="Полная стоимость путевки"
                                              :invalid-feedback="veeErrors.first('price')">
                                    <b-form-input :value="_summa_full" readonly></b-form-input>
                                </b-form-group>
                            </div>
                        </div>

                        <b-form-group>
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="confirm_summ" value="1"
                                       v-model="confirm_summ">
                                <label class="custom-control-label" for="confirm_summ">Я подтверждаю, что сумма будущего
                                    счета мною проверена</label>
                            </div>
                        </b-form-group>


                        <div class="row">
                            <div class="col col-lg-12">
                                <b-form-group
                                    label='Загрузка документа'
                                    description='Подготовьте и загрузите документ'
                                    :state="validateState('text_admin_hidden')"
                                    :invalid-feedback="veeErrors.first('text_admin_hidden')"
                                >
                                    <b-form-file id="file-default" v-model='document_file'
                                                 placeholder="Выберите файл..."
                                                 drop-placeholder="Кидать файло сюды..."
                                    ></b-form-file>
                                </b-form-group>
                            </div>
                        </div>

                    </template>
                </b-tab>


                <!--<b-tab title="В кассу объекта" :disabled="!enableDirectPayment">
                    <template v-if="booking_type===3">
                        <div class="row">
                            <div class="col col-lg-6">
                                <b-form-group label="Дата заезда">
                                    <input class="form-control" :value='printDate(voucherx.date_begin_iso)' readonly/>
                                </b-form-group>
                            </div>

                            <div class="col col-lg-6">
                                <b-form-group label="Полная стоимость путевки"
                                              :invalid-feedback="veeErrors.first('price')">
                                    <b-form-input :value="_summa_full" readonly></b-form-input>
                                </b-form-group>
                            </div>
                        </div>

                        <b-form-group>
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="confirm_summ_3" value="1"
                                       v-model="confirm_summ">
                                <label class="custom-control-label" for="confirm_summ_3">Я подтверждаю, что стоимость
                                    бронирования сверена с документом</label>
                            </div>
                        </b-form-group>

                        <div class="row">
                            <div class="col col-lg-12">
                                <b-form-group
                                    label='Загрузка документа'
                                    description='Подготовьте и загрузите документ'
                                    :state="validateState('text_admin_hidden')"
                                    :invalid-feedback="veeErrors.first('text_admin_hidden')"
                                >
                                    <b-form-file id="file-default" v-model='document_file'
                                                 placeholder="Выберите файл..."
                                                 drop-placeholder="Кидать файло сюды..."
                                    ></b-form-file>
                                </b-form-group>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-lg-12">
                                <b-form-group
                                    label='Выбор телефонного звонка'
                                    description="не доделано пока"
                                    class="alert-danger"
                                >
                                    <div class="input-group">
                                        <input :input="telecall_number" class="form-control"/>
                                        <button type="button" class="btn btn-primary"
                                                @click.prevent="show_telecall_select_dialog=true"><i
                                            class="icon-search"></i>Выбрать
                                        </button>
                                    </div>
                                </b-form-group>
                            </div>
                        </div>

                    </template>
                </b-tab>-->

                <b-tab title="Счет от объекта 2" :disabled="!enableDirectPayment">
                    <template v-if="booking_type===3">

                        <div class="row">
                            <div class="col">
                                <b-form-group>
                                    <b-form-group label="Поставщик: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                                        <v-select
                                            v-model="supplier_id"
                                            :options="companies"
                                            placeholder="Компания поставщик"
                                            label="title"
                                            :reduce="x=>x.id"
                                        ></v-select>
                                    </b-form-group>
                                </b-form-group>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col col-lg-6">
                                <b-form-group label="Дата заезда">
                                    <input class="form-control" :value='printDate(voucherx.date_begin_iso)' readonly/>
                                </b-form-group>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col col-lg-6">
                                <b-form-group
                                    label="Полная стоимость путевки"
                                    :invalid-feedback="veeErrors.first('price')"
                                >
                                    <b-form-input :value="_summa_full" readonly></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col col-lg-6">
                                <b-form-group
                                    label="Сумма счета"
                                    :state="validateState('invoice_value')"
                                    :invalid-feedback="veeErrors.first('invoice_value')"
                                    :description="invoice_value_not_changed?'расчитываеся автоматически как [сумма_путевки] - [вознаграждение]':''"
                                >
                                    <b-form-input type="text"
                                                  v-model.number="_invoice_value"
                                                  v-validate="{decimal:2,min_value:1,max_value:33000000,required:true}"
                                                  id="invoice_value"
                                                  name="invoice_value"
                                                  data-vv-as="'Сумма счета'"
                                                  :state="validateState('invoice_value')"
                                                  :class="invoiceValueClass"
                                                  @input="onChangeInvoiceValue"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12" v-if="minRewardPercent">
                                <b class="text-danger">
                                    минимальный % вознаграждения по программам в путевке {{ this.minRewardPercent }}%
                                </b>
                            </div>


                            <div class="col col-xs-6 col-lg-3">

                                <b-form-group
                                    label="Вознаграждение объекта"
                                    :state="validateState('fee_value')"
                                    :invalid-feedback="veeErrors.first('fee_value')"
                                    :description="'базовое вознаграждение объекта ' + formatPriceKop(_base_fee)"
                                >
                                    <b-form-input type="text"
                                                  v-model.number="_fee_value"
                                                  v-validate="{decimal:2,min_value:0,max_value:33000000,required:true}"
                                                  id="fee_value"
                                                  name="fee_value"
                                                  data-vv-as="'Вознаграждение объекта'"
                                                  :state="validateState('fee_value')"
                                                  @input="onChangeFee"
                                                  :class="feeValueClass"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col col-xs-6 col-lg-3">

                                <b-form-group
                                    label="% Вознаграждения"
                                    :state="validateState('fee_value')"
                                    :invalid-feedback="veeErrors.first('fee_value')"
                                    :description="'базовый % вознаграждения ' + hotel.procent_ref_obj + '%' + minRewardPercentText"
                                >
                                    <b-form-input type="text"
                                                  v-model.number="_fee_percent"
                                                  v-validate="{decimal:2,min_value:0,max_value:100,required:true}"
                                                  id="fee_percent"
                                                  name="fee_percent"
                                                  data-vv-as="'Вознаграждение объекта'"
                                                  :state="validateState('fee_percent')"
                                                  @input="onChangeFeePercent"
                                                  :class="feePercentClass"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col col-lg-6">
                                <b-form-group
                                    label="Сумма к оплате в объекте"
                                    :state="validateState('to_pay_value')"
                                    :invalid-feedback="veeErrors.first('to_pay_value')"
                                >
                                    <b-form-input type="text"
                                                  v-model.number="_to_pay_value"
                                                  v-validate="{decimal:2,min_value:1,max_value:33000000,required:true}"
                                                  id="to_pay_value"
                                                  name="to_pay_value"
                                                  data-vv-as="'Сумма к оплате в объекте'"
                                                  :state="validateState('to_pay_value')"
                                                  readonly
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>

                        <b-form-group>
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="confirm_summ_3" value="1"
                                       v-model="confirm_summ">
                                <label class="custom-control-label" for="confirm_summ_3">Я подтверждаю, что стоимость
                                    бронирования сверена с документом</label>
                            </div>
                        </b-form-group>

                        <div class="row">
                            <div class="col col-lg-12">
                                <b-form-group
                                    label='Загрузка документа'
                                    description='Подготовьте и загрузите документ'
                                    :state="validateState('text_admin_hidden')"
                                    :invalid-feedback="veeErrors.first('text_admin_hidden')"
                                >
                                    <b-form-file id="file-default" v-model='document_file'
                                                 placeholder="Выберите файл..."
                                                 drop-placeholder="Кидать файло сюды..."
                                    ></b-form-file>
                                </b-form-group>
                            </div>
                        </div>

                    </template>
                </b-tab>

                <b-tab title="Предварительное" :disabled="!enablePrebook">
                    <template v-if="booking_type===4">

                        <div class="row">
                            <div class="col">
                                <b-form-group>
                                    <b-form-group label="Поставщик: " label-for="basicSelect" :label-cols="3"
                                                  :horizontal="false   ">
                                        <v-select
                                            v-model="supplier_id"
                                            :options="companies"
                                            placeholder="Компания поставщик"
                                            label="title"
                                            :reduce="x=>x.id"
                                        ></v-select>
                                    </b-form-group>
                                </b-form-group>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col col-lg-6">
                                <b-form-group label="Дата заезда">
                                    <input class="form-control" :value='printDate(voucherx.date_begin_iso)' readonly/>
                                </b-form-group>
                            </div>
                            <div class="col col-lg-6">
                                <b-form-group
                                    label="Крайняя дата поступления цен"
                                    label-for="wait_invoice_date"
                                    description="Дата до которой должны быть введены цены"
                                    :state="validateState('wait_invoice_date')"
                                    :invalid-feedback="veeErrors.first('wait_invoice_date')"
                                >
                                    <b-input-group style="witdh:100%">
                                        <v-date-picker
                                            v-model='wait_invoice_date'
                                            id="wait_invoice_date_pb"
                                            name="wait_invoice_date"
                                            data-vv-as="'Крайняя дата получения счета'"
                                            :state="validateState('wait_invoice_date')"
                                            :attributes="datepicker_attributes"
                                            :min-date='new Date()'
                                            :max-date='(new Date()).addDays(360).correctWeekendForward()'

                                        >
                                            <input
                                                id="wait_invoice_date_input_pb"
                                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                                class="form-control form-date-picker"
                                                readonly
                                                v-bind="inputProps"
                                                v-on="inputEvents"
                                            />

                                        </v-date-picker>
                                        <button type="button" class="btn btn-secondary"
                                                @click.prevent="wait_invoice_date=null"><i class="fa fa-times"></i>
                                        </button>
                                    </b-input-group>
                                </b-form-group>
                            </div>
                        </div>
                        <b-form-group>
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="confirm_prebook" value="1"
                                       v-model="confirm_prebook">
                                <label class="custom-control-label" for="confirm_prebook">Я подтверждаю, что
                                    предварительное бронирование выполнено</label>
                            </div>
                        </b-form-group>


                        <div class="row">
                            <div class="col col-lg-12">
                                <b-form-group
                                    label='Загрузка документа'
                                    description='Подготовьте и загрузите документ'
                                    :state="validateState('text_admin_hidden')"
                                    :invalid-feedback="veeErrors.first('text_admin_hidden')"
                                >
                                    <b-form-file id="file-default" v-model='document_file'
                                                 placeholder="Выберите файл..."
                                                 drop-placeholder="Кидать файло сюды..."
                                    ></b-form-file>
                                </b-form-group>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-lg-12">
                                <b-form-group
                                    label='Выбор телефонного звонка'
                                    description="не доделано пока"
                                    class="alert-danger"
                                >
                                    <div class="input-group">
                                        <input :input="telecall_number" class="form-control"/>
                                        <button type="button" class="btn btn-primary"
                                                @click.prevent="show_telecall_select_dialog=true"><i
                                            class="icon-search"></i>Выбрать
                                        </button>
                                    </div>
                                </b-form-group>
                            </div>
                        </div>

                    </template>
                </b-tab>

                <b-tab title="ПК - забронировать" :disabled="!enableProfkurort">
                    <template v-if="booking_type===5">

                        <b-button size="sm" variant="outline-primary" @click="createPkBooking()">
                            Оформить бронь в профкурорте
                        </b-button>

                    </template>
                </b-tab>

            </b-tabs>
            <!--hotel = [{{hotel}}]-->

            Метод взаиморасчетов c агентством: {{ this.voucherx.company.settlements_metod ? 'За вычетом агентского вознаграждения' : 'Полная сумма' }}<br>
            Сумма вознаграждения агентства составит: {{ formatPriceKop(this.voucherx.summa_ref_agency) }}₽

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()" :disabled="!canCreate">
                    Сохранить
                </b-button>
            </template>
        </b-modal>

        <telecall-select-dialog v-model="show_telecall_select_dialog"></telecall-select-dialog>
    </div>
</template>


<script>
    import {functions} from '@/functions';
    import Tabs from "../views/base/Tabs.vue";
    import miniToastr from 'mini-toastr'
    import TelecallSelectDialog from '@/dialogs/TelecallSelectDialog'
    import {CONSTANTS} from '@/constants'
    import { functions_company } from '@/functions/company.js';
    import { functions_hotel } from '@/functions/hotel.js';

    export default {
        components: {Tabs, TelecallSelectDialog},
        name: 'BookingCreateDialog',
        mixins: [functions, functions_company, functions_hotel],
        data: function () {
            return {
                booking_type: 0,
                bookerId: 1, // профкурорт

                external_id: null,
                supplier_id: null,
                invoice_number: null,
                invoice_date: null,
                invoice_value: null,
                fee_value: null,
                fee_percent: null,
                to_pay_value: null,

                redemption_date: null,
                document_file: null,
                fee_included: false,
                fee_to_be_payed: false,
                invoice_value_not_changed: true,
                fee_value_changed: false,
                fee_percent_changed: false,
                telecall: null,
                show_telecall_select_dialog: false,
                confirm_summ: false,
                confirm_prebook: false,

                hotel: Object,
            };
        },
        model: {
            prop: "showModal",
            event: "hide"
        },
        props: {
            showModal: [Number, Boolean],
            voucherx: Object,
            hotelx: Object,
            bookingsx: Array,
        },
        watch: {},
        methods: {
            handleCancel: function () {
                this.$emit("hide", false);
            },
            handleOk: function () {
                this.$validator.validateAll().then((result) => {
                        if (!result) return false;

                        this.createBooking(function (self) {
                            self.$emit("booked", false);
                            self.$emit("hide", false);
                        }, this, false);
                    }
                );
            },
            createPkBooking: function () {
                this.createBooking(function (self) {
                    self.$emit("booked", false);
                    self.$emit("hide", false);
                }, this, true);
            },
            createBooking: function (onSuccess = null, param = null, force_book_pk = false) {
                let voucher_id = this.voucherx.id;
                let booking_data = this.booking_data;
                let formdata = new FormData();
                formdata.append('booking_type', this.booking_type);
                formdata.append('voucher_id', this.voucherx.id);
                formdata.append('supplier_id', this.supplier_id);
                formdata.append('external_id', this.external_id);
                formdata.append('invoice_number', this.invoice_number);
                formdata.append('invoice_date', this.dateToISO(this.invoice_date));
                formdata.append('invoice_value', this.invoice_value);
                formdata.append('fee_value', this.fee_value);
                formdata.append('fee_percent', this.fee_percent);
                formdata.append('to_pay_value', this.to_pay_value);
                formdata.append('fee_included', this.fee_included);
                formdata.append('fee_to_be_payed', this.fee_to_be_payed);
                formdata.append('redemption_date', this.dateToISO(this.redemption_date));
                formdata.append('wait_invoice_date', this.dateToISO(this.wait_invoice_date));
                formdata.append('document_file', this.document_file);
                this.httpPrepare();
                this.$http.post(this.apiurl('booking/create'), formdata, {
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then(function (response) {
                    response = this.httpSuccess(response);
                    if (response.result === 'success') {
                        miniToastr["success"]('Бронь создана', null, CONSTANTS.TOAST_SUCCESS_LIFETIME);
                        this.executeFunction(onSuccess, param);
                    } else {
                        miniToastr["error"]('При создании брони произошла ошибка', null, CONSTANTS.TOAST_ERROR_LIFETIME);
                    }
                }, this.httpError);

            },
            calculate: function () {
                if (this.fee_included) {
                    if (this.fee_to_be_payed) {
                        this.to_pay_value = this.invoice_value;
                    } else {
                        this.to_pay_value = this.invoice_value - this.fee_value;
                    }
                } else {
                    this.to_pay_value = this.invoice_value;
                }
            },
            calculate_invoice_value: function () {
                if (this.invoice_value_not_changed) {
                    if (this.fee_included) {
                        this.invoice_value = this.voucherx.summa_full;
                        console.log('calculate_invoice_value - 1')
                    } else {
                        this.invoice_value = this.voucherx.summa_full - this.fee_value;
                        console.log('calculate_invoice_value - 2')
                    }
                } else {
                    console.log('calculate_invoice_value - 3')
                }
            },
            onChangeInvoiceValue: function () {
                console.log('onChangeInvoiceValue 1')
                this.invoice_value_not_changed = false;
                if (this.fee_percent_changed) {
                    console.log(1)
                    if (this.fee_included) {
                        this.fee_value = Math.round(this.invoice_value * this.fee_percent / 100  );
                    }
                    else{
                        this.fee_value = Math.round(this.invoice_value * this.fee_percent / 100 / (1 - this.fee_percent / 100));
                    }
                }
                else if (this.fee_value_changed) {
                    console.log(2)
                    if (this.fee_included) {
                        this.fee_percent = Math.round(this.fee_value / this.invoice_value * 10000)/100;
                    }
                    else {
                        this.fee_percent = Math.round(this.fee_value / (this.invoice_value+this.fee_value) * 10000)/100;
                    }
                }
                else {
                    console.log(3)
                    if (this.fee_included) {
                        this.fee_value = Math.round(this.invoice_value * this.fee_percent / 100  );
                    }
                    else{
                        this.fee_value = Math.round(this.invoice_value * this.fee_percent / 100 / (1 - this.fee_percent / 100));
                    }
                }
                this.calculate();
            },
            onChangeFee: function () {
                console.log('onChangeFee 1')
                this.calculate_invoice_value();
                this.fee_value_changed = true;
                this.fee_percent_changed = false;
                if (this.fee_included) {
                    this.fee_percent = Math.round(this.fee_value / (this.invoice_value) * 10000) / 100;
                }
                else {
                    this.fee_percent = Math.round(this.fee_value / (this.invoice_value + this.fee_value) * 10000) / 100;
                }
                this.calculate();
            },
            onChangeFeePercent: function () {
                console.log('onChangeFeePercent 1')
                this.calculate_invoice_value();
                this.fee_percent_changed = true;
                this.fee_value_changed = false;
                if (this.fee_included) {
                    this.fee_value = Math.round(this.fee_percent * this.invoice_value) / 100 ;
                }
                else {
                    this.fee_value = Math.round(this.fee_percent * this.invoice_value / 100 / (1 - this.fee_percent / 100));
                }

                this.calculate();
            },
            onChangeFeeIncluded: function () {
                this.calculate_invoice_value();
                this.calculate();
            },
            onChangeFeeToBePayed: function () {
                this.calculate_invoice_value();
                this.calculate();
            },
            onChangeInvoiceDate: function () {
                this.redemption_date = this.invoice_date.addDays(10).correctBack(this.voucherx.date_begin_iso).correctWeekendBack().correctForward(new Date());
            },
            programReward: function (id) {
                for (let i=0; i<this.hotel.programs.length; i++) {
                    if (this.hotel.programs[i].id === id) {
                        return this.hotel.programs[i].reward_percent;
                    }
                }
                return null;
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {
                }
            },
            invoiceValueClass: function () {
                if (this.invoice_value_not_changed) {
                    return 'auto-calc-field'
                }
                return ''
            },
            feeValueClass: function () {
                if (!this.fee_value_changed) {
                    return 'auto-calc-field'
                }
                return ''
            },
            feePercentClass: function () {
                if (!this.fee_percent_changed) {
                    return 'auto-calc-field'
                }
                return ''
            },
            not_fee_to_be_payed: {
                get: function () {
                    return !this.fee_to_be_payed
                },
                set: function (newValue) {
                    this.fee_to_be_payed = newValue ? 0 : 1;
                }
            },
            canCreate: function () {
                switch (this.booking_type) {
                    case 0:
                        return true;
                    case 1:
                        return true;
                    case 2:
                        return !!this.confirm_summ;
                    case 3:
                        return !!this.confirm_summ;
                    case 4:
                        return !!this.confirm_prebook;
                    case 5:
                        return true;
                }
            },
            telecall_number: function () {
                if (!this.is(this.telecall)) {
                    return '';
                }
                return this.telecall.number;
            },
            enableProfkurort: function () {
                return this.is(this.voucherx.summa_full) && (!this.voucherx.m_payment_obj) && (!this.hotel.extern_disabled)
            },
            enableInvoice: function () {
                return this.is(this.voucherx.summa_full) && (!this.voucherx.m_payment_obj)
            },
            enableInvoiceWait: function () {
                return this.is(this.voucherx.summa_full) && (!this.voucherx.m_payment_obj)
            },
            enableDirectPayment: function () {
                return this.is(this.voucherx.summa_full) && this.voucherx.m_payment_obj
            },
            enablePrebook: function () {
                return !this.is(this.voucherx.summa_full)
            },

            _invoice_value: {
                set: function (val) {
                    this.invoice_value = Math.round(val * 100);
                },
                get: function () {
                    return this.invoice_value / 100;
                }
            },

            _fee_value: {
                set: function (val) {
                    this.fee_value = Math.round(val * 100);
                },
                get: function () {
                    return this.fee_value / 100;
                }
            },

            _fee_percent: {
                set: function (val) {
                    this.fee_percent = val;
                },
                get: function () {
                    return this.fee_percent;
                }
            },


            _to_pay_value: {
                set: function (val) {
                    this.to_pay_value = Math.round(val * 100);
                },
                get: function () {
                    return this.to_pay_value / 100;
                }
            },

            _summa_full: {
                set: function (val) {
                },
                get: function () {
                    return this.voucherx.summa_full / 100;
                }
            },

            _base_fee: function () {
                return Math.round(this.invoice_value * this.hotel.procent_ref_obj /100);
            },

            minRewardPercent: function() {
                let minReward = null;
                console.log(this.voucherx)
                console.log(this.hotel)
                for (let i=0; i<this.voucherx.guests.length; i++) {
                    let reward = this.programReward(this.voucherx.guests[i].program_id);
                    if (reward && ((!minReward) || (reward < minReward))) {
                        minReward = reward;
                    }
                }
                return  minReward;
            },
            minRewardPercentText: function () {
                let minReward = this.minRewardPercent;
                if (minReward) {
                    return ' минимальный % вознаграждения по программам в путевке' + this.minRewardPercent + '%';
                }
                else {
                    return '';
                }
            },
        },
        created: function () {
            this.hotel = this.hotelx;
            this.fee_included = this.hotel.sys_invoice_type === CONSTANTS.INVOICE_INCLIDES_FEE;
            if (this.enableDirectPayment) {
                this.fee_included = true;
            }
            this.fee_to_be_payed = this.hotel.sys_payment_type === CONSTANTS.PAYMENT_WITH_FEE;
            this.loadCompaniesHotels(this.booking_id, this.afterBookingLoaded)
            let self = this;
            console.log('this.hotel.sys_invoice_type=', this.hotel.sys_invoice_type);
            console.log('this.hotel.sys_payment_type=', this.hotel.sys_payment_type);
            console.log('this.fee_included=', this.fee_included);
            console.log('this.fee_to_be_payed=', this.fee_to_be_payed);
        },
        mounted: function () {
            this.fee_value = Math.round(this.hotel.procent_ref_obj * this.voucherx.summa_full / 100);
            this.fee_percent = this.hotel.procent_ref_obj
            this.calculate_invoice_value();
            this.calculate();
            this.wait_invoice_date = (new Date()).addDays(3).correctWeekendForward();
            console.log(this.hotel.id)
            console.log(this.hotelx.id)
            console.log(this.hotelx.company_id)
            this.supplier_id = this.hotelx.company_id;
        },
        updated: function () {
        },
    }
</script>
